import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=533abd1c&"
import script from "./DataTable.vue?vue&type=script&lang=ts&"
export * from "./DataTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('533abd1c')) {
      api.createRecord('533abd1c', component.options)
    } else {
      api.reload('533abd1c', component.options)
    }
    module.hot.accept("./DataTable.vue?vue&type=template&id=533abd1c&", function () {
      api.rerender('533abd1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-viz/v2/DataTable.vue"
export default component.exports